<template>
  <div>
    <div class="vx-col w-full mb-base flex">
      <div class="flex-1 px-2">
        <vx-card>
          <vs-list>
            <vs-list-header icon-pack="feather" icon="icon-paperclip" :title="`ข้อมูลนำออกจากระบบ`"></vs-list-header>
            <div>
              <vs-list-item title="สัญญากู้ยืมเงิน">
                <vs-button type="line" line-origin="left" color="success" @click="openUrl(pathLoanAgreement)">เรียกดู</vs-button>
              </vs-list-item>
              <vs-list-item title="สัญญาค้ำประกัน">
                <vs-button type="line" line-origin="left" color="success" @click="openUrl(pathSuretyContract)">เรียกดู</vs-button>
              </vs-list-item>
              <vs-list-item title="หนังสือให้ความยินยอม">
                <vs-button type="line" line-origin="left" color="success" @click="openUrl(pathPdpaConsentBorrower)">เรียกดู</vs-button>
              </vs-list-item>
              <vs-list-item title="หนังสือให้ความยินยอม (ผู้ค้ำประกัน)">
                <vs-button type="line" line-origin="left" color="success" @click="openUrl(pathPdpaConsentSureties)">เรียกดู</vs-button>
              </vs-list-item>
            </div>
          </vs-list>
        </vx-card>
      </div>
      <div class="flex-1 px-2">
        <vx-card>
          <vs-list>
            <vs-list-header icon-pack="feather" icon="icon-paperclip" :title="`ข้อมูลนำเข้าระบบ`"></vs-list-header>
            <vs-list-item v-for="file in filesSort" :key="file.id" :title="file.description" >
              <vs-button type="line" line-origin="left" color="success" @click="download(file)" :disabled="!file.fileName">เรียกดู</vs-button>
              <vs-button class="btn-icon" size="medium" color="warning" v-if="contract.smartAppStatus == 'Inspectioned'" @click="upload(file.id)">อัพโหลด</vs-button>
            </vs-list-item>
          </vs-list>
        </vx-card>
      </div>
    </div>
    <vs-prompt
      @accept="onUploadFile"
      color="warning"
      :is-valid="selectedFile !== null"
      :title="$t('notification.confirm-upload-title')"
      :active.sync="modalUpload">
      <div class="con-exemple-prompt">
        {{ $t('notification.confirm-upload-message') }}
        <input class="mt-5 mb-5" type="file" @change="onFileChange" ref="inputFile"/>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { getUploadsUrl } from '@/utils/upload'
/* eslint-disable no-unused-vars */

import { createNamespacedHelpers  } from 'vuex'

const { mapActions: mapAccountingActions, mapState: mapAccountingState } = createNamespacedHelpers('Accounting')
const { mapActions: mapMasterActions, mapState: mapMasterState  } = createNamespacedHelpers('Master')

export default {
  data() {
    return {
      modalUpload: false,
      selectedFile: null,
      form:{
          description: ""
      },
      reportServer: process.env.VUE_APP_REPORT_SERVER
    };
  },
  async created () {
    const vm = this
    await vm.getContractFiles({form: {id: vm.$route.params.id}});
  },
  computed: {
    ...mapAccountingState(['contract', 'files']),
    pathLoanAgreement(){
      return `${this.reportServer}/pdf/loanAgreement?id=${this.contract.id}&version=v.3.0.0`;
    },
    pathSuretyContract(){
      return `${this.reportServer}/pdf/suretyContract?id=${this.contract.id}&version=v.3.0.0`;
    },
    pathPdpaConsentBorrower(){
      return `${this.reportServer}/pdf/pdpaConsentBorrower?id=${this.contract.id}&version=v.1.0.0`;
    },
    pathPdpaConsentSureties(){
      return `${this.reportServer}/pdf/pdpaConsentSureties?id=${this.contract.id}&version=v.1.0.0`;
    },
    filesSort(){
      const fileContracts = this.files.filter(file => file.fileFrom === 'Contract')
      const fileBorrowers = this.files.filter(file => file.fileFrom === 'Borrower')
      const fileSureties = this.files.filter(file => file.fileFrom === 'Surety')
      return [
        ...fileContracts,
        ...fileBorrowers,
        ...fileSureties
      ]
    }
  },
  methods: {
    ...mapAccountingActions(['getContractFiles', 'uploadFile', 'updateFile']),
    download(file){
      const url = getUploadsUrl(file.fileName)
      window.open(url, '_blank');
    },
    openUrl(url){
      window.open(url, '_blank');
    },
    upload (id) {
      const vm = this;
      vm.actionID = id
      vm.modalUpload = true;
    },
    onFileChange(e) {
      const selectedFile = e.target.files[0]; // accessing file
      this.selectedFile = selectedFile;
    },
    async onUploadFile() {
      const vm = this
      const formData = new FormData()
      formData.append("file", this.selectedFile);  // appending file
      const result = await vm.uploadFile ({
        id: vm.$route.params.id,
        form: {
          formData: formData
        },
        vm
      });
      await vm.updateFile({
        id: vm.actionID,
        form: {
          fileName: result.fileName,
          fileType: result.fileType,
          pathUrl: result.pathUrl
        },
        vm
      });
      await vm.getContractFiles({form: {id: vm.$route.params.id}});
      vm.selectedFile = null;
      // vm.$refs.inputFile.value = null;
    },
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  }
};
</script>

<style >
</style>
